import {
  RawTenant,
  RawSit,
  RawLabel,
  RawPolicy,
  UITenant,
  UISit,
  UILabel,
  UIPolicy,
} from './types';

// No-op mappers for now. Central place to handle future schema changes.

export const mapTenant = (t: RawTenant): UITenant => ({ ...t });

export const mapSit = (s: RawSit): UISit => ({
  ...s,
  tenants: (s.tenants ?? []).map(mapTenant),
});

export const mapLabel = (l: RawLabel): UILabel => ({
  ...l,
  tenants: (l.tenants ?? []).map(mapTenant),
});

export const mapPolicy = (p: RawPolicy): UIPolicy => ({
  ...p,
  tenants: (p.tenants ?? []).map(mapTenant),
});
